import React from "react";
import PropTypes from "prop-types";

import styles from "./Typeahead.css";

const TypeaheadMenu = (props) => <div className={styles.menu}>{props.children}</div>;

TypeaheadMenu.propTypes = {
  children: PropTypes.node,
};

export default TypeaheadMenu;
